import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NewDownloadIcon, NewDownloadIconActive } from "../../assets/images";
import moment from "moment";
import FileSaver from "file-saver";
import { toast } from "react-hot-toast";
import { DropDownType } from "../../commonTypes/clientDirectoryTypes";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { downloadTimesheetReportApi } from "../../apis/timeSheetApis";
type UserBasicDetailsType = {
  user?: DropDownType;
  activityCode?: DropDownType;
  type?: DropDownType;
}
type AppProps = {
  startDate?: string,
  loginData?: LoginResponseType,
  endDate?: string,
  token?: string | null,
  userBasicDetails: UserBasicDetailsType;
  isViewUserDropDown?: boolean;
  downloadFinalData?: any;
  timeSheetReportDataList: any[];

}
const DownloadTimeSheetReport = ({ startDate,
  endDate,
  token,
  userBasicDetails,
  isViewUserDropDown,
  loginData,
  timeSheetReportDataList,
  downloadFinalData,

}: AppProps) => {

  const handlePrepareDownload = () => {
    let params: any = {
      'start_date': downloadFinalData?.startDate,
      'end_date': downloadFinalData?.endDate,
      "user_id": downloadFinalData?.userBasicDetails?.user?.value,
      "type": downloadFinalData?.userBasicDetails?.type?.value,
      "activity_code": downloadFinalData?.userBasicDetails?.activityCode?.label,
      token
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: any) => {
    ;
    let name = downloadFinalData?.userBasicDetails?.user?.label !== "Select.."
      ? downloadFinalData?.userBasicDetails?.user?.label : loginData?.first_name;
    let reportName = name ? name + "_" +
      downloadFinalData?.startDate
      + "_" +
      downloadFinalData?.endDate
      +
      ".xlsx"
      : "report";
    downloadTimesheetReportApi(params).then((response: any) => {

      let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8" });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  }

  return (

    <OverlayTrigger
      placement="bottom"
      delay={{ show: 250, hide: 250 }}
      overlay={
        <Tooltip id="button-view-download-invoice">Download Reports</Tooltip>
      }
    >
      {/* <DropdownToggle className="mt-1"  outline> */}
      <button className="btn form-control mt-1" style={{border:'1px solid #bfcbe1'}} onClick={() => handlePrepareDownload()}
        disabled={!timeSheetReportDataList?.length}>
        <img src={NewDownloadIcon} alt="download icon" />
      </button>

      {/* </DropdownToggle> */}
    </OverlayTrigger>
  );
};


const mapStateToProps = (state: RootState) => ({
  // token: state.auth.token,
  loginData: state.auth.loginData,
  timeSheetReportDataList: state.timeSheet.timeSheetReportDataList,
});


export default connect(
  mapStateToProps,
)(DownloadTimeSheetReport);
